import { baseServiceInvoiceSchema } from "@redotech/redo-billing-common/service-invoice";
import * as z from "zod";

export const getFinalizedRecoverInvoices = {
  name: "getFinalizedRecoverInvoices" as const,
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
